import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-modulo-retencion',
  templateUrl: './modulo-retencion.component.html',
  styleUrls: ['./modulo-retencion.component.scss']
})
export class ModuloRetencionComponent implements OnInit {
  tabselected
  constructor(private activateRoute: ActivatedRoute,) {
    if (this.activateRoute.snapshot.paramMap.get('accion') != null) {
      this.tabselected=this.activateRoute.snapshot.paramMap.get('accion')
    }
   }

  ngOnInit(): void {
  }
  selecttab(tab) {
    this.tabselected = tab
  }
}
